export enum Phase {
    LOBBY = 0,
    LOBBY_READY = 1,
    SLOT_MACHINE = 2,
    CHOOSING_SOLUTION_CARDS = 3,
    PICK_DILEMMA = 4,
    QUESTION_CARD = 5,
    ACTION_CARD = 6,
    CHOOSE_SOLUTION = 7,
    RENDER_SPIN_WHEEL = 8,
    NINE = 9,
    POSTGAME = 10,
    

    CONFETTI_CELEBRATION = 13,
    SOLUTION_CHOSEN = 14,
    SOLUTION_CHOSEN_REWARD = 15,
    INTRODUCTION = 16
}